<template>
  <svg
    width="48"
    height="46"
    viewBox="0 0 48 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="icon-curved-arrow-right2"
  >
    <path
      d="M39.2929 45.7071C39.6834 46.0976 40.3166 46.0976 40.7071 45.7071L47.0711 39.3431C47.4616 38.9526 47.4616 38.3195 47.0711 37.9289C46.6805 37.5384 46.0474 37.5384 45.6569 37.9289L40 43.5858L34.3431 37.9289C33.9526 37.5384 33.3195 37.5384 32.9289 37.9289C32.5384 38.3195 32.5384 38.9526 32.9289 39.3431L39.2929 45.7071ZM41 45C41 29.6861 38.6272 18.3715 32.1933 10.9015C25.7259 3.39246 15.366 -1.34334e-06 -8.74228e-08 0L8.74228e-08 2C15.1291 2 24.7691 5.34627 30.6779 12.2067C36.6203 19.106 39 29.7913 39 45L41 45Z"
      fill="white"
    />
  </svg>
</template>

<script setup lang="ts"></script>
